import {stores} from 'mutants-microfx';
import {toJS} from 'mobx';
const user = stores.user;
export default function UserData(){
    const userOptions = toJS(user.options);
    return userOptions;
}
